type DateType = 'datetime' | 'date';
type ParseDateOptions = {
  type?: DateType;
  convertToLocale?: boolean;
  shortYear?: boolean;
  hideDay?: boolean;
};

export default function parseDate(
  originalDate: string | Date,
  options: ParseDateOptions = {
    type: 'datetime',
    convertToLocale: true,
    shortYear: false,
    hideDay: false,
  },
) {
  if (!originalDate) return '';

  const date = new Date(originalDate);
  const timezoneInMs = date.getTimezoneOffset() * 1000 * 60;

  !options.convertToLocale && date.setTime(date.getTime() + timezoneInMs);

  return options.type === 'date'
    ? date.toLocaleDateString(undefined, {
        ...(!options.hideDay && { day: 'numeric' }),
        month: 'numeric',
        year: options.shortYear ? '2-digit' : 'numeric',
      })
    : date.toLocaleString(undefined, {
        ...(!options.hideDay && { day: 'numeric' }),
        month: 'numeric',
        year: options.shortYear ? '2-digit' : 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      });
}
